import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 sm:px-6 lg:px-8 border-t border-dark-border" data-id="element-46">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-47">
        <p className="text-sm text-zinc-500" data-id="element-48">
          © 2026 Decode This Dream. All rights reserved.
        </p>
        <div className="flex items-center gap-6" data-id="element-49">
          <a href="#" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-50">
            Terms of Service
          </a>
          <a href="#" className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-51">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>;
}